import React from "react";

function VariantSection({ variants, setProduct, product }) {

  const addVariant = () => {
    setProduct({
      ...product,
      variants: [...variants, { size: "", color: "", stockQuantity: 0, isActive: true }]
    });
  };

  const removeVariant = (index) => {
    const updated = variants.filter((_, i) => i !== index);
    setProduct({ ...product, variants: updated });
  };

  const handleChange = (index, field, value) => {
    const updated = [...variants];
    updated[index][field] = value;
    setProduct({ ...product, variants: updated });
  };

  return (
  <div>

    {variants.map((v, i) => (
      <div key={i} className="card p-3 mb-3 shadow-sm rounded-3">

        <div className="row g-2">

          <div className="col-md-4">
            <input
              type="text"
              placeholder="Size"
              className="form-control"
              value={v.size}
              onChange={(e) => handleChange(i, "size", e.target.value)}
            />
          </div>

          <div className="col-md-4">
            <input
              type="text"
              placeholder="Color"
              className="form-control"
              value={v.color}
              onChange={(e) => handleChange(i, "color", e.target.value)}
            />
          </div>

          <div className="col-md-3">
            <input
              type="number"
              placeholder="Stock"
              className="form-control"
              value={v.stockQuantity}
              onChange={(e) =>
                handleChange(i, "stockQuantity", Number(e.target.value))
              }
            />
          </div>

          <div className="col-md-1 d-flex align-items-center">
            <button
              type="button"
              className="btn btn-danger btn-sm"
              onClick={() => removeVariant(i)}
            >
              ✕
            </button>
          </div>

        </div>

      </div>
    ))}

    <button
      className="btn btn-outline-primary"
      type="button"
      onClick={addVariant}
    >
      + Add Variant
    </button>
  </div>
);
}

export default VariantSection;